import angular from 'angular'

import envRaw from '../utils/env-raw'

import { noop, isFinite } from 'lodash-es'

import Template from './gallery-modal-one.component.ejs'

angular
  .module('ggs.gallery-modal-one')
  .component('ggsGalleryModalOne', {
    template: Template({
      LE: envRaw.liveEditMode
    }),
    controller: GalleryModalOneComponent,
    bindings: {
      ggsStylerNew: '<',
      ggsProperties: '<',
      ggsPostVoteEmitter: '<',
      ggsPostFlagEmitter: '<',
      ggsPopupOpenHandler: '<',
      ggsPopupClosedHandler: '<',
      ggsOneAttachCallback: '<',
      ggsVoteChangeHandler: '<',
      ggsVoteCountHideHandler: '<',
      ggsVotingDisallowHandler: '<'
    }
  })

function GalleryModalOneComponent(
  $scope,
  LazyResource,
  DefineMethod,
  DefineHandler) {

  const sign = 'galleryOne'
  const $ctrl = $scope.$ctrl = this

  $ctrl.slideIndex = 0

  $ctrl.wrapH = DefineHandler(sign)
  $ctrl.wrapM = DefineMethod(sign)

  const extList = LazyResource(
    'prev',
    'next',
    'open',
    'close',
    'slide',
    'isOpen',
    'isClosed')

  $ctrl.wrapH('listAttachCallback', (
    extListPrev,
    extListNext,
    extListOpen,
    extListClose,
    extListSlide,
    extListIsOpen,
    extListIsClosed) => {

    extList.prev.allow(extListPrev)
    extList.next.allow(extListNext)
    extList.open.allow(extListOpen)
    extList.close.allow(extListClose)
    extList.slide.replace(extListSlide)
    extList.isOpen.allow(extListIsOpen)
    extList.isClosed.allow(extListIsClosed)
  })

  $ctrl.fakeGetPrevModal = noop
  $ctrl.fakeGetNextModal = noop
  $ctrl.wrapH('fakeModalDisplayedHandler', noop)

  $ctrl.wrapH('$onInit', () => {
    return $ctrl.ggsOneAttachCallback(
      $ctrl.extOneOpen,
      $ctrl.extOneClose,
      $ctrl.extOneIsOpen,
      $ctrl.extOneIsClosed)
  })

  $ctrl.wrapH('modalReadyHandler', () => {
    if (isFinite($ctrl.slideIndex)) {
      return extList.slide($ctrl.slideIndex)
    }
  })

  $ctrl.wrapM('extOneOpen', (post, slideIndex) => {
    $ctrl.slideIndex = slideIndex
    return extList.open(post)
  })

  $ctrl.wrapM('extOneClose', extList.close)
  $ctrl.wrapM('extOneIsOpen', extList.isOpen)
  $ctrl.wrapM('extOneIsClosed', extList.isClosed)
}
